import { imageUrl } from '../helpers'

interface Props {
  eventReference?: wowaudit.EventReference
  className?: string
}

const EventAvatar = ({ eventReference, className }: Props) => {
  return (
    <img
      className={`rounded-full ${className}`}
      src={eventReference?.primaryActivity?.instance?.legacyImagePath}
      onError={({ currentTarget }) => {
        currentTarget.onerror = null
        currentTarget.src = imageUrl('bnet-temp.png')
      }}
    />
  )
}

export default EventAvatar
